import { render, staticRenderFns } from "./marketingTable.vue?vue&type=template&id=98f69a22&"
import script from "./marketingTable.vue?vue&type=script&lang=js&"
export * from "./marketingTable.vue?vue&type=script&lang=js&"
import style0 from "./marketingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports